module.exports = __webpack_public_path__ + "img/client8.2a8ecdc6.png";